import React from "react";
import { Tooltip } from "@mantine/core";

const ToolTip = ({ position, toolTipLabel, imgsrc }) => {
  return (
    <>
      <Tooltip
        position={position}
        label={toolTipLabel}
        isMobileScreen={false}
        withArrow
        arrowOffset={12}
        arrowSize={6}
        offset={22}
        color="white"
        // -----> Passing inline CSS because external CSS didn't wok <----- \\
        styles={{
          tooltip: { color: "#000000", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)" },
        }}
      >
        <span>{imgsrc}</span>
      </Tooltip>
    </>
  );
};

export default ToolTip;
